import React from 'react';
import { Shield, Sparkles, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { mockCompanyInfo } from '../mock';

export const Hero = () => {
  return (
    <section id="home" className="bg-gradient-to-br from-gray-50 to-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                <span className="text-red-600">Safety</span> and{' '}
                <span className="text-red-600">Cleanliness</span>,{' '}
                <span className="block">Seamlessly Delivered</span>
              </h1>
              <p className="text-xl text-gray-600 max-w-xl">
                Integrated security and cleaning solutions for businesses, residential estates, 
                and institutions across South Africa. One provider, complete peace of mind.
              </p>
            </div>

            {/* Value Points */}
            <div className="space-y-3">
              {[
                'Cost-efficient integrated solutions',
                '24/7 reliability and rapid response',
                'Vetted professionals and eco-friendly approach'
              ].map((point, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{point}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg font-semibold transition-all duration-200 transform hover:scale-105"
                onClick={() => document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Get Free Quote
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                variant="outline" 
                className="border-2 border-red-600 text-red-600 hover:bg-red-50 px-8 py-4 text-lg font-semibold transition-all duration-200"
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Our Services
              </Button>
            </div>

            {/* Quick Contact */}
            <div className="pt-6 border-t border-gray-200">
              <p className="text-gray-600 mb-2 font-medium">Need immediate assistance?</p>
              <a 
                href={`tel:${mockCompanyInfo.phone}`}
                className="text-2xl font-bold text-red-600 hover:text-red-700 transition-colors duration-200"
              >
                {mockCompanyInfo.phone}
              </a>
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
              {/* Services Icons */}
              <div className="flex justify-center space-x-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <Shield className="w-8 h-8 text-red-600" />
                  </div>
                  <p className="text-sm font-semibold text-gray-700">Security</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <Sparkles className="w-8 h-8 text-red-600" />
                  </div>
                  <p className="text-sm font-semibold text-gray-700">Cleaning</p>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-6 pt-6 border-t border-gray-100">
                <div className="text-center">
                  <p className="text-3xl font-bold text-gray-900">500+</p>
                  <p className="text-sm text-gray-600">Happy Clients</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-gray-900">24/7</p>
                  <p className="text-sm text-gray-600">Support</p>
                </div>
              </div>

              {/* Service Areas */}
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-700 mb-2">Service Areas:</p>
                <div className="flex flex-wrap gap-2">
                  {mockCompanyInfo.provinces.map((province) => (
                    <span 
                      key={province}
                      className="bg-white px-3 py-1 rounded-full text-xs text-gray-600 border"
                    >
                      {province}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-red-100 rounded-full opacity-50"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-red-50 rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
};